import { IconClipboard } from 'central-icons/IconClipboard';
import { IconEmail1 } from 'central-icons/IconEmail1';
import startCase from 'lodash/startCase';
import CopyToClipboard from 'react-copy-to-clipboard';

import { IconButton, Popover } from '@revelio/ui';

import { useToast } from '../../../../../../shared/hooks/useToast';
import styles from './email-popover.module.css';

interface EmailPopoverProps {
  emails?: Record<string, string>;
  trigger: React.ReactNode;
}

export const EmailPopover = ({ emails, trigger }: EmailPopoverProps) => {
  const toast = useToast();

  if (!emails) return <>{trigger}</>;

  return (
    // Stays in the DOM tree: the hover card that owns this trigger closes on
    // its own onMouseLeave, and a portaled surface counts as leaving it.
    <Popover placement="right" arrow trigger={trigger} portal={false}>
      <div className={styles.list}>
        {Object.entries(emails).map(([key, value], i) => {
          if (!value) {
            return null;
          }

          return (
            <div className={styles.entry} key={`${key}-${i}`}>
              <span className={styles.label}>
                {startCase(key).toUpperCase()}
              </span>
              <div className={styles.valueRow}>
                <span className={styles.value}>{value}</span>
                <CopyToClipboard
                  text={value}
                  onCopy={(text, result) => {
                    if (result) {
                      toast({
                        title: 'Email Copied Successfully',
                        description: 'Email copied to clipboard.',
                        status: 'success',
                        duration: 4000,
                        position: 'top-right',
                      });
                    }
                  }}
                >
                  <IconButton
                    variant="ghost"
                    size="sm"
                    shape="rounded"
                    icon={<IconClipboard />}
                    aria-label="copy email"
                    className={styles.action}
                  />
                </CopyToClipboard>
                <IconButton
                  variant="ghost"
                  size="sm"
                  shape="rounded"
                  icon={<IconEmail1 />}
                  aria-label="email"
                  className={styles.action}
                  onClick={() => (window.location.href = `mailto:${value}`)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </Popover>
  );
};
